import React from 'react';
import { motion } from 'framer-motion';
import FlipTile from '../components/FlipTile';

const MoreServices = () => {
  const services = [
    {
      title: "Graphic Design",
      icon: "🎨",
      description: "Professional design for logos, social media graphics, and marketing materials.",
      color: "bg-blue-100"
    },
    {
      title: "Bookkeeping",
      icon: "📊",
      description: "Expense tracking, invoicing, financial reports, and basic accounting tasks.",
      color: "bg-green-100"
    },
    {
      title: "Market Research",
      icon: "🔍",
      description: "Competitor analysis, customer surveys, and industry trend reports.",
      color: "bg-purple-100"
    },
    {
      title: "Content Writing",
      icon: "✍️",
      description: "Blog posts, newsletters, product descriptions, and marketing copy.",
      color: "bg-yellow-100"
    },
    {
      title: "Website Management",
      icon: "💻",
      description: "Website updates, content management, and basic technical support.",
      color: "bg-red-100"
    },
    {
      title: "Travel Planning",
      icon: "✈️",
      description: "Business trip itineraries, hotel bookings, and travel arrangements.",
      color: "bg-teal-100"
    },
    {
      title: "Project Management",
      icon: "📋",
      description: "Task coordination, team updates, and project timeline tracking.",
      color: "bg-orange-100"
    },
    {
      title: "Customer Support",
      icon: "🤝",
      description: "Email management, ticket resolution, and client communication.",
      color: "bg-indigo-100"
    }
  ];

  return (
    <section id="more-services" className="section bg-primary-50">
      <div className="container">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-primary-700 mb-4">More Virtual Assistant Services</h2>
          <p className="text-neutral-600 text-lg max-w-2xl mx-auto">
            Specialized Solutions for Your Business Needs
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
            >
              <FlipTile
                title={service.title}
                icon={service.icon}
                description={service.description}
                color={service.color}
              />
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="text-center mt-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <a 
            href="https://calendly.com/adam-cothes/va-consultation" 
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Book Appointment
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default MoreServices;